// eslint-disable-next-line @typescript-eslint/no-restricted-imports -- This is the wrapper itself
import NextLink from "next/link";
import type { ComponentPropsWithoutRef } from "react";
import { forwardRef } from "react";

// Change default behavior of NextLink
// We don't want to prefetch pages by default.
export const Link = forwardRef<
  HTMLAnchorElement,
  ComponentPropsWithoutRef<typeof NextLink>
>(function Link(props, ref) {
  return <NextLink ref={ref} prefetch={false} {...props} />;
});
